import React, { useState } from "react";
import {
  TitleContainer,
  TitleText,
  SubtitleText,
  TitleTextHolder,
  PaymentLinkContainer,
  PaymentLinkHeader,
  TitleSearchContainer,
  PaymentLinkTitleText,
  FilterContainer,
  CalendarTextHolder,
  CalendarText,
  CalendarLinkText,
  ExportDataButton,
  ExportIcon,
  ExportButtonandSettingIconPhone,
} from "../../../pages/Dashboard/Dashboard.styles";

import { colors } from "../../../theme/color";
import SearchBar from "../../../components/SearchBar/SearchBar";
import { LuCalendarDays } from "react-icons/lu";
import { RxDividerVertical } from "react-icons/rx";
import Table from "../../../pages/DashboardReturningUsers/TableReturningUsers/Table";
import { newTableHeaderData } from "./TransactionTableData";
import { environment } from "../../../env";

import { useQuery } from "@apollo/client";
import { GET_TRANSACTION_BY_ORGANIZATION_ID } from "../../../graphql/queries/transaction";
import ErrorPage from "../../ErrorComponent/ErrorPage";

const Dashboard = () => {
  const { loading, error, data } = useQuery(
    GET_TRANSACTION_BY_ORGANIZATION_ID,
    {
      variables: {
        ...environment.paymentLinkService,
        payload: {
          limit: 10,
          page: 1,
        },
      },
    }
  );

  const [filteredTransactions, setFilteredTransactions] = useState([]);

  function handleSearch(searchItem: string): void {
    if (!searchItem || !data?.getAllTransactionsByOrganizationId?.data) {
      return;
    }
    const filteredData = data.getAllTransactionsByOrganizationId.data.filter(
      (transaction: any) => {
        if (
          transaction.date &&
          transaction.amount &&
          transaction.description &&
          typeof transaction.date === "string" &&
          typeof transaction.amount === "number" &&
          typeof transaction.description === "string"
        ) {
          return (
            transaction.date.includes(searchItem) ||
            transaction.amount.toString().includes(searchItem) ||
            transaction.description.includes(searchItem)
          );
        } else {
          return false;
        }
      }
    );

    setFilteredTransactions(filteredData || []);
  }

  const transaction = data?.getAllTransactionsByOrganizationId?.data || [];
  if (error)
    return (
      <>
        <ErrorPage />
      </>
    );
  if (loading) return <p>Loading...</p>;

  return (
    <>
      <TitleContainer>
        <TitleTextHolder>
          <TitleText>Transactions</TitleText>
          <SubtitleText>View all transaction history</SubtitleText>
        </TitleTextHolder>
      </TitleContainer>
      <PaymentLinkContainer>
        <PaymentLinkHeader>
          <TitleSearchContainer>
            <PaymentLinkTitleText>Transaction History</PaymentLinkTitleText>
            <SearchBar onSearch={handleSearch} />
          </TitleSearchContainer>
          <FilterContainer>
            <LuCalendarDays
              color={colors.ButtonBackgroundColors.primaryDefaultButton}
              size={"20px"}
            />
            <CalendarTextHolder>
              <CalendarText>From: </CalendarText>
              <CalendarLinkText>Start Date</CalendarLinkText>
            </CalendarTextHolder>
            <RxDividerVertical color={colors.LIGHT_GRAY} />
            <CalendarTextHolder>
              <CalendarText>To: </CalendarText>
              <CalendarLinkText> End Date</CalendarLinkText>
            </CalendarTextHolder>
          </FilterContainer>
          <ExportButtonandSettingIconPhone>
            <ExportDataButton>
              <ExportIcon src="/assets/icons/export_icon.png" />
              <CalendarText>Export Data</CalendarText>
            </ExportDataButton>
          </ExportButtonandSettingIconPhone>
        </PaymentLinkHeader>
        <Table
          headData={newTableHeaderData}
          bodyData={transaction}
          status="transaction"
        />
      </PaymentLinkContainer>
    </>
  );
};

export default Dashboard;
